import Modal from "react-bootstrap/Modal";
import logoPNG from "../assets/img/logo.png";

function ModalConfirm(props) {
  const { messageModal, show, setShow, functionStorage } = props;
  
  const handleClose = () => {
    setShow(false)    
  };


  function confirmAction(){
    handleClose();
    functionStorage.current(true);    
    functionStorage.current = function(){};
  }

  function cancelAction(){
    handleClose();
    functionStorage.current(false);
    functionStorage.current = function(){};
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName="rounded-4 overflow-hidden border border-0 greenArbitragem style-modal-confirm"
        backdropClassName="style-backdrop-modal-loading"
      >
        <Modal.Body className="text-light">
          <div className="d-flex flex-column align-items-center text-center py-3 px-5">
            <img
              src={logoPNG}
              alt="Apito"
              className="style-size-image-logo-loading-page-modal"
            />
            
            <div className="text-light fs-4 fw-bold">{messageModal}</div>

            <div className="style-container-btns-confirm w-100 mt-3">

                <button className="btn btn-danger fw-bold  style-btn-danger" onClick={cancelAction}>
                  NÃO
                </button>

                <button className="btn btn-success fw-bold btn style-btn-update-success" onClick={confirmAction}>
                  SIM
                </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalConfirm;
